module.exports = __webpack_public_path__ + "static/tom-hanks-a613960ed6566f3f55e7f1a5af33f91b.jpg";